import { IconWrapper } from '../runtime';
export default IconWrapper('copy', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M4.5 6.74988H3.25C2.42157 6.74988 1.75 7.42145 1.75 8.24988V12.7499C1.75 13.5783 2.42157 14.2499 3.25 14.2499H7.75C8.57843 14.2499 9.25 13.5783 9.25 12.7499V11.4999M8.25 9.24988H12.75C13.5784 9.24988 14.25 8.57831 14.25 7.74988V3.24988C14.25 2.42145 13.5784 1.74988 12.75 1.74988H8.25C7.42157 1.74988 6.75 2.42145 6.75 3.24988V7.74988C6.75 8.57831 7.42157 9.24988 8.25 9.24988Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});